import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';

const AuthorityLevelUpdatePage: React.FC = () => {
  return <div>AuthorityLevelUpdate</div>;
};

export default dashboardWrapper(AuthorityLevelUpdatePage);
